export const paginatorRoute = '/paginator/';
